import { render, staticRenderFns } from "./KETListTrainer.vue?vue&type=template&id=145c6b9c&"
import script from "./KETListTrainer.vue?vue&type=script&lang=js&"
export * from "./KETListTrainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports